import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=323b7e3a"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=323b7e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports